import React from "react";
import { Card, Row, Col } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Hàng stat card cho mỗi tab log. cards = [{ key, title, value, icon, iconColor, bgColor }].
// Style đồng bộ với dashboard-stat-cards.js (Tailwind + FontAwesome).
function LogStatCards({ cards = [], loading }) {
    return (
        <Row gutter={[12, 12]} style={{ marginBottom: 16 }}>
            {cards.map((c) => (
                <Col key={c.key} xs={12} sm={12} md={6}>
                    <Card size="small" className="shadow-sm h-full" loading={loading}>
                        <div className="flex items-center gap-3">
                            <div className={`p-2.5 rounded-xl ${c.bgColor} flex-shrink-0`}>
                                <FontAwesomeIcon icon={c.icon} className={`text-lg ${c.iconColor}`} />
                            </div>
                            <div className="min-w-0">
                                <div className="text-content-3 text-xs">{c.title}</div>
                                <div className="text-lg font-bold text-content truncate">
                                    {(c.value ?? 0).toLocaleString("vi-VN")}
                                </div>
                            </div>
                        </div>
                    </Card>
                </Col>
            ))}
        </Row>
    );
}

export default LogStatCards;
